import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PageFixRepoService } from '@client/app/services/api/pagefix-repo/page-fix-repo.service';
import { PAGE_FIX_SELECTOR_QUERIES } from '@client/app/modules/page-fix/constants/page-fix-selector-queries';
import { PAGE_FIX_CHANGE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-change-types';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'page-fix-form-custom',
    templateUrl: './page-fix-form-custom.component.html',
    standalone: false,
})
export class PageFixFormCustomComponent implements OnInit {
    @Input() resolve: any;
    @Output() close = new EventEmitter<any>();
    @Output() dismiss = new EventEmitter<void>();

    model: any = {};

    constructor (private pageFixRepoService: PageFixRepoService) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.model = safeClone(this.resolve.pageFix || {});
        if (!this.model.change) {
            this.model.change = {};
        }
    }

    submit (): void {
        const model = {
            change_type: PAGE_FIX_CHANGE_TYPES.word,
            selector: this.getSelectorValue(),
            change: {
                value: this.model.change?.value,
            },
        };
        let promise;

        if (!this.resolve.pageFix) {
            promise = this.pageFixRepoService.create(model, undefined);
        } else {
            promise = this.pageFixRepoService.update(this.resolve.pageFix, model, {});
        }

        promise.then((pageFix: any) => {
            this.closeModal(pageFix);
        });
    }

    cancel (): void {
        this.dismiss.emit();
    }

    closeModal (result: any): void {
        this.close.emit({ $value: result });
    }

    private getSelectorValue (): string {
        return PAGE_FIX_SELECTOR_QUERIES.tree_walker + ';' + this.model.custom_selector;
    }

}
